var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/App.tsx";
import React from 'react';
import { connect } from 'react-redux';
import { useRouter } from 'Hooks';
import { GeneralModal } from 'Components/utility';
import { getStandaloneReturnUri } from 'Utilities/standaloneFlow';
const mapState = ({
  nav: {
    location,
    initErrorStatus,
    initErrorCode,
    redirect_uri,
    data
  },
  env
}) => {
  const {
    registration_return_uri
  } = env;
  return {
    initErrorStatus,
    initErrorCode,
    redirect_uri,
    standalone_return_uri: getStandaloneReturnUri(env),
    registration_return_uri,
    location,
    data
  };
};
const connector = connect(mapState);
const App = ({
  initErrorStatus,
  initErrorCode,
  redirect_uri,
  registration_return_uri,
  standalone_return_uri,
  location,
  data
}) => {
  const {
    Component,
    props
  } = useRouter(location, initErrorStatus, initErrorCode, redirect_uri, data, standalone_return_uri, registration_return_uri);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Component, Object.assign({}, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(GeneralModal, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 7
    }
  }));
};
export default connector(App);